export const UIEvents = {
    ControlEdited: Symbol('control:edited'),

    ValidationChanged: Symbol('validation-changed'),

    ControlValidationUpdated: Symbol('control-validation-updated'),

    MenuClosed: Symbol('menu-closed')
};
